import React, { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import Select from "../../atoms/input/Select";
import {
	examTypeOptionIfCombo1,
	examTypeOptionIfCombo2,
	examTypeOptionIfCombo3,
	examTypeOptionIfCombo4,
	examTypeOptionIfCombo5,
	comboOption,
	speakLanguageOption,
} from "../../../static";
import {
	selectedComboSnState,
	selectorState,
} from "../../../recoil/admin/question";
import useQuestionActions from "../../../api/hooks/admin/question";
import { useQuery } from "@tanstack/react-query";

const AdminQuestionSelect = () => {
	const { fetchCombo } = useQuestionActions();

	const [selectorValues, setSelectorValues] = useRecoilState(selectorState);

	const comboSn = useRecoilValue(selectedComboSnState);

	useQuery({
		queryKey: ["fetchCombo"],
		queryFn: () => fetchCombo({ sn: comboSn }),
		retry: false,
		onSuccess: (context) => {
			let nextValues = { ...selectorState };
			if (comboSn && context?.data[0]?.combo) {
				nextValues.combo = context?.data[0]?.combo;
			}
			if (comboSn && context?.data[0]?.room_type) {
				nextValues.room_type = context?.data[0]?.room_type;
			}
			if (comboSn && context?.data[0]?.combo_catagory) {
				nextValues.combo_catagory = context?.data[0]?.combo_catagory;
			}
			setSelectorValues({ ...nextValues });
		},
	});

	return (
		<>
			<div className="flex-start mb-10">
				<div style={{ marginRight: "35px" }}>
					<span>대분류</span>

					<Select
						placeholder="선택"
						options={comboOption}
						value={selectorValues.combo ? selectorValues.combo : ""}
						required={true}
						onChange={(e) =>
							setSelectorValues({
								...selectorValues,
								combo: e.target.value,
								combo_catagory: "",
							})
						}
						style={{ marginLeft: "10px" }}
					/>
				</div>
				<div style={{ marginRight: "35px" }}>
					<span>중분류</span>
					<Select
						placeholder="선택"
						required={true}
						options={
							selectorValues.combo == comboOption[0].value
								? examTypeOptionIfCombo1
								: selectorValues.combo == comboOption[1].value
								? examTypeOptionIfCombo2
								: selectorValues.combo == comboOption[2].value
								? examTypeOptionIfCombo3
								: selectorValues.combo == comboOption[3].value
								? examTypeOptionIfCombo4
								: selectorValues.combo == comboOption[4].value
								? examTypeOptionIfCombo5
								: []
						}
						value={
							selectorValues.combo_catagory ? selectorValues.combo_catagory : ""
						}
						onChange={(e) =>
							setSelectorValues({
								...selectorValues,
								combo_catagory: e.target.value,
							})
						}
						style={{ marginLeft: "10px" }}
					/>
				</div>
				<div style={{ marginRight: "35px" }}>
					<span>시험유형</span>
					<Select
						placeholder="선택"
						options={speakLanguageOption}
						value={selectorValues.room_type ? selectorValues.room_type : ""}
						required={true}
						onChange={(e) => {
							setSelectorValues({
								...selectorValues,
								room_type: e.target.value,
							});
						}}
						style={{ marginLeft: "10px" }}
					/>
				</div>
			</div>
		</>
	);
};

export default AdminQuestionSelect;
